import { render, staticRenderFns } from "./SensorInfo.vue?vue&type=template&id=06b17982&scoped=true"
import script from "./SensorInfo.vue?vue&type=script&lang=ts"
export * from "./SensorInfo.vue?vue&type=script&lang=ts"
import style0 from "./SensorInfo.vue?vue&type=style&index=0&id=06b17982&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b17982",
  null
  
)

export default component.exports